import request from "@/utils/request";
//1, 成果详情
export function getResultDetail(data){
    return request({
        url:'/getResultDetail',
        data:data,
        method:'get'
    })
}

//2, 成果列表
export function getResults(data){
    return request({
        url:'/getResults',
        data:data,
        method:'get'
    })
}
//3, 撤销当前用户提交的指定成果
export function cancelResult(data){
    return request({
        url:'/web/cancelResult',
        data:data,
        method:'post'
    })
}
//4, 查询当前用户提交的成果详情
export function getMyResultDetail(data){
    return request({
        url:'/web/getMyResultDetail',
        data:data,
        method:'get'
    })
}
//5, 我发布的成果列表
export function getMyResults(data){
    return request({
        url:'/web/getMyResults',
        data:data,
        method:'get'
    })
}

//6, 发布成果
export function newResult(data){
    return request({
        url:'/web/newResult',
        data:data,
        method:'post'
    })
}
//7, 编辑成果
export function updateResult(data){
    return request({
        url:'/web/updateResult',
        data:data,
        method:'post'
    })
}
